<template>
    <b-row class="rowbg">
        <b-col md="12">
            <b-card>
                <b-card-title>Privacy Statement</b-card-title>
                <b-card-text>
                    <h2>Privacy statement</h2>
<p><strong>Privacyverklaring Ridder en de Prins Entertainment</strong></p>
<p>Versie 01-09-2024</p>
<p>Ridder en de Prins Entertainment, gevestigd aan Slinger 2,3995 DE, Houten, Nederland, is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze privacyverklaring.</p>
<p>Contactgegevens:<br /><a href="https://www.ridderendeprins.nl">Ridder en de Prins</a> <br />Slinger 2 <br />3995 DE Houten <br />Nederland <br />030 - 207 702 7</p>
<p>Kristel de Groot is de Functionaris Gegevensbescherming van Ridder en de Prins Entertainment. Zij is te bereiken via <a href="mailto:kristel@ridderendeprins.nl">kristel@ridderendeprins.nl</a>.</p>
<p><strong>Persoonsgegevens die wij verwerken</strong></p>
<p>Ridder en de Prins Entertainment verwerkt je persoonsgegevens doordat je gebruik maakt van onze diensten en/of omdat je deze gegevens zelf aan ons verstrekt. Hieronder vind je een overzicht van de persoonsgegevens die wij verwerken:</p>
<ul>
<li>Voor- en achternaam</li>
<li>Geslacht</li>
<li>Leeftijd</li>
<li>Adresgegevens</li>
<li>Telefoonnummer</li>
<li>E-mailadres</li>
<li>Gegevens ingevuld in het Online Grote Boek</li>
<li>Gegevens over jouw activiteiten op onze website</li>
<li>Internetbrowser en apparaat type</li>
</ul>
<p><strong>Bijzondere en/of gevoelige persoonsgegevens die wij verwerken</strong></p>
<p>Ridder en de Prins Entertainment verwerkt de volgende bijzondere en/of gevoelige persoonsgegevens van jou:</p>
<ul>
<li>gegevens van personen jonger dan 16 jaar. Onze website en/of dienst heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 16 jaar. Tenzij ze toestemming hebben van ouders of voogd. We kunnen echter niet controleren of een bezoeker ouder dan 16 is. Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten van hun kinderen, om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming. Als je er van overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben verzameld over een minderjarige, neem dan contact met ons op via <a href="mailto:info@ridderendeprins.nl">info@ridderendeprins.nl</a>, dan verwijderen wij deze informatie.</li>
</ul>
<p><strong>Met welk doel en op basis van welke grondslag wij persoonsgegevens verwerken</strong></p>
<p>Ridder en de Prins Entertainment verwerkt jouw persoonsgegevens voor de volgende doelen:</p>
<ul>
<li>Het afhandelen van jouw betaling</li>
<li>Je te kunnen bellen of e-mailen indien dit nodig is om onze dienstverlening uit te kunnen voeren</li>
<li>Je te informeren over wijzigingen van onze diensten en producten</li>
<li>Je de mogelijkheid te bieden een account aan te maken</li>
<li>Om goederen en diensten bij je af te leveren</li>
</ul>
<p><strong>Geautomatiseerde besluitvorming</strong></p>
<p>Ridder en de Prins Entertainment neemt op basis van geautomatiseerde verwerkingen geen besluiten over zaken die (aanzienlijke) gevolgen kunnen hebben voor personen. Het gaat hier om besluiten die worden genomen door computerprogrammas of -systemen, zonder dat daar een mens (bijvoorbeeld een medewerker van Ridder en de Prins Entertainment) tussen zit.</p>
<p><strong>Hoe lang we persoonsgegevens bewaren</strong></p>
<p>Ridder en de Prins Entertainment bewaart je persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor je gegevens worden verzameld. Wij hanteren de volgende bewaartermijnen voor de volgende (categorie&euml;n) van persoonsgegevens:</p>
<p><table border="1">
<tbody>
<tr>
<td>Gegevens</td>
<td>Termijn</td>
<td>Reden</td>
</tr>
<tr>
<td>Informatie gevuld in het Online Grote Boek over aanwezigen</td>
<td>Tot twee maanden na de show</td>
<td>Ten behoeve van het uitvoeren van de show</td>
</tr>
<tr>
<td>Geanonimiseerde informatie gevuld in het Online Grote Boek over aanwezigen</td>
<td>5 jaar</td>
<td>Ten behoeve van bedrijfsmatige analyse</td>
</tr>
<tr>
<td>Informatie gevuld in het Online Grote Boek over het bezoek</td>
<td>5 jaar</td>
<td>Ten behoeve van facturatieproces en optimaliseren werkproces</td>
</tr>
<tr>
<td>Contactgegevens Show</td>
<td>5 jaar</td>
<td>Ten behoeve van facturatieproces en optimaliseren werkproces</td>
</tr>
</tbody>
</table>
</p>
<p><strong>Delen van persoonsgegevens met derden</strong></p>
<p>Ridder en de Prins Entertainment deelt jouw persoonsgegevens met verschillende derden als dit noodzakelijk is voor het uitvoeren van de overeenkomst en om te voldoen aan een eventuele wettelijke verplichting. Met bedrijven die je gegevens verwerken in onze opdracht, sluiten wij een verwerkersovereenkomst om te zorgen voor eenzelfde niveau van beveiliging en vertrouwelijkheid van jouw gegevens. Ridder en de Prins Entertainment blijft verantwoordelijk voor deze verwerkingen. Daarnaast verstrekt Ridder en de Prins Entertainment jouw persoonsgegevens aan andere derden. Dit doen wij alleen met jouw nadrukkelijke toestemming.</p>
<p><table border="1">
<tbody>
<tr>
<td>Categorie</td>
<td>Categorie derde partij</td>
<td>Doel</td>
</tr>
<tr>
<td>Informatie in Online Grote Boek</td>
<td>Hosting partij</td>
<td>Optimaal functioneren website</td>
</tr>
<tr>
<td>Informatie in Online Grote Boek m.b.t. cadeaus</td>
<td>Leverancier Cadeaus</td>
<td>Leveren cadeaus ten behoeve van show</td>
</tr>
</tbody>
</table>
</p>
<p><strong>Cookies, of vergelijkbare technieken, die wij gebruiken</strong></p>
<p>Ridder en de Prins Entertainment gebruikt geen cookies of vergelijkbare technieken.</p>
<p><strong>Gegevens inzien, aanpassen of verwijderen</strong></p>
<p>Je hebt het recht om je persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heb je het recht om je eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van jouw persoonsgegevens door Ridder en de Prins Entertainment en heb je het recht op gegevensoverdraagbaarheid. Dat betekent dat je bij ons een verzoek kan indienen om de persoonsgegevens die wij van jou beschikken in een computerbestand naar jou of een ander, door jou genoemde organisatie, te sturen. Je kunt een verzoek tot inzage, correctie, verwijdering, gegevensoverdraging van je persoonsgegevens of verzoek tot intrekking van je toestemming of bezwaar op de verwerking van jouw persoonsgegevens sturen naar <a href="mailto:info@ridderendeprins.nl">info@ridderendeprins.nl</a>. Om er zeker van te zijn dat het verzoek tot inzage door jou is gedaan, vragen wij jou een kopie van je identiteitsbewijs met het verzoek mee te sturen. Maak in deze kopie je pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van je privacy. We reageren zo snel mogelijk, maar binnen vier weken, op jouw verzoek. Ridder en de Prins Entertainment wil je er tevens op wijzen dat je de mogelijkheid hebt om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link: <a href="https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons">https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons</a></p>
<p><strong>Hoe wij persoonsgegevens beveiligen</strong></p>
<p>Ridder en de Prins Entertainment neemt de bescherming van jouw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als jij het idee hebt dat jouw gegevens toch niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact met ons op via <a title="&zwnj;" href="mailto:info@ridderendeprins.nl">info@ridderendeprins.nl</a></p>
<p>Deze privacy statement is ook beschikbaar als <a  href="https://media.ridderendeprins.nl/images/RedP/legal/Privacy_statement_01_09_2024.pdf">download</a></p>   
                </b-card-text>
            </b-card>
        </b-col>
</b-row>
</template>

<script>
    export default {
        name: 'Privacy'
    }
</script>

<style>

</style>